import { Link, NavLink, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import copy_link_icon from '../../assets/frontend/images/copy_link_icon.png';
import email_icon from '../../assets/frontend/images/email_icon.png';
import facebook_icon from '../../assets/frontend/images/facebook_icon.png';
import whats_app_icon from '../../assets/frontend/images/whats_app_icon.png';
import instagram_icon from '../../assets/frontend/images/instagram_icon.png';
import tik_tok_icon from '../../assets/frontend/images/tik_tok_icon.png';

import swal from 'sweetalert';

const SharePanel = ({ onClose, track, tracklist }) => {

  const currentUrl = window.location.href;
  const shareText = `${track?.title || 'Check this out'} on ${tracklist?.title || 'Romergence.com'}:\n${currentUrl}`;

  // Copy to clipboard
  function copyToClipboard(e) {
    e.stopPropagation();
    navigator.clipboard.writeText(currentUrl).then(() => {
      swal('Copied to clipboard!', currentUrl, 'success');
    });
  }

  // Share via email
  function sendEmail(e) {
    e.stopPropagation();
    const subject = encodeURIComponent(`Check this out on Romergence.com`);
    const body = encodeURIComponent(shareText);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  }

  // Facebook
  function shareOnFacebook(e) {
    e.stopPropagation();
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`, '_blank');
  }

  // WhatsApp
  function shareOnWhatsapp(e) {
    e.stopPropagation();
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`, '_blank');
  }

  // Instagram (manual sharing)
  function shareOnInstagram(e) {
    e.stopPropagation();
    //swal('Instagram Sharing', 'Instagram does not support direct web sharing.\nLink copied to clipboard!', 'info');
    navigator.clipboard.writeText(currentUrl);

    swal({
      title: 'Share on Instagram?',
      text: 'Link copied to clipboard! A new tab will open shortly. Do you want to proceed?',
      icon: 'info',
      buttons: {
        cancel: {
          text: 'Cancel',
          visible: true,
          className: 'swal-button--cancel',
        },
        confirm: {
          text: 'OK',
          visible: true,
          className: 'swal-button--confirm',
        },
      },
      dangerMode: false,
    }).then((willProceed) => {
      if (willProceed) {
        delayedOpen('https://www.instagram.com', 1000);
        swal({
          title: 'Opening Instagram...',
          text: 'Please wait a moment.',
          icon: 'success',
          buttons: false,
          timer: 250,
        });
      }
    });
  }

  // TikTok (manual sharing)
  function shareOnTikTok(e) {
    e.stopPropagation();
    //swal('TikTok Sharing', 'TikTok does not support direct web sharing.\nLink copied to clipboard!', 'info');
    navigator.clipboard.writeText(currentUrl);

    swal({
      title: 'Share on TikTok?',
      text: 'Link copied to clipboard! A new tab will open shortly. Do you want to proceed?',
      icon: 'info',
      buttons: {
        cancel: {
          text: 'Cancel',
          visible: true,
          className: 'swal-button--cancel',
        },
        confirm: {
          text: 'OK',
          visible: true,
          className: 'swal-button--confirm',
        },
      },
      dangerMode: false,
    }).then((willProceed) => {
      if (willProceed) {
        delayedOpen('https://www.tiktok.com', 1000);
        swal({
          title: 'Opening TikTok...',
          text: 'Please wait a moment.',
          icon: 'success',
          buttons: false,
          timer: 250,
        });
      }
    });
  }

  function delayedOpen(url, delay = 1500) {
    const win = window.open('', '_blank');
    setTimeout(() => {
      win.location.href = url;
    }, delay);
  }

  return (
    <div className="options-content">
      <div className="panel large p-20l-10s">
        <div className="horizontal-container justify-left gap-lg-md bb1-555 pb-10l-5s">
          {track && tracklist.type === 'liked' && track.tracklistImageURL ? (
            <span className="center-everything b1-555">
              <img src={track.tracklistImageURL} alt={track.tracklistTitle} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
              <img src={track.tracklistImageURL} alt={track.tracklistTitle} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
            </span>
          ) : (
            tracklist.type === 'liked' ? (
              <span className="center-everything b1-555">
                <img src={tracklist.image_url} alt={tracklist.title} className="hide-for-small-only" width="50" />
                <img src={tracklist.image_url} alt={tracklist.title} className="show-for-small-only" width="35" />
              </span>
            ) : (
              <span className="center-everything b1-555">
                <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
                <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
              </span>
            )
          )}
          {track && tracklist.type === 'liked' && track.tracklistTitle ? (
            <span className="">
              <span className="font-orbitron font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{track.title}</span>
              <div className="font-orbitron font-size-18l-16m-14s font-weight-500 txt-fff letter-spacing-0px italic uppercasse pt-10l-5s">{track ? track.tracklistTitle : ''}</div>
            </span>
          ) : (
            track && tracklist.type !== 'liked' ? (
              <span className="">
                <span className="font-orbitron font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{track.title}</span>
                <div className="font-orbitron font-size-18l-16m-14s font-weight-500 txt-fff letter-spacing-0px italic uppercasse pt-10l-5s">{tracklist ? tracklist.title : ''}</div>
              </span>
            ) : (
              <span className="">
                <span className="font-orbitron font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{tracklist ? tracklist.title : ''}</span>
              </span>
            )
          )}
          {!track && !tracklist && (
            <span className="">
              <div className="font-poppins font-size-16 font-weight-500 txt-fff">No track or tracklist loaded</div>
            </span>
          )}
        </div>

        <div className="grid-x">
          <div className="large-4 medium-6 small-6 cell ptb-10">
            <span className="hover-opacity-50" onClick={(e) => copyToClipboard(e, track)}>
              <img src={copy_link_icon} alt="Copy Link Icon" className="pr-10 hide-for-small-only" width="55" />
              <img src={copy_link_icon} alt="Copy Link Icon" className="pr-10 show-for-small-only" width="45" />
              <span className="font-poppins font-size-18l-16m font-weight-500 txt-ddd">Copy Link</span>
            </span>
          </div>
          <div className="large-4 medium-6 small-6 cell ptb-10">
            <span className="hover-opacity-50" onClick={(e) => sendEmail(e, track)}>
              <img src={email_icon} alt="Copy Link Icon" className="pr-10 hide-for-small-only" width="55" />
              <img src={email_icon} alt="Copy Link Icon" className="pr-10 show-for-small-only" width="45" />
              <span className="font-poppins font-size-18l-16m font-weight-500 txt-ddd">Email</span>
            </span>
          </div>
          <div className="large-4 medium-6 small-6 cell ptb-10">
            <span className="hover-opacity-50" onClick={(e) => shareOnFacebook(e, track)}>
              <img src={facebook_icon} alt="Copy Link Icon" className="pr-10 hide-for-small-only" width="55" />
              <img src={facebook_icon} alt="Copy Link Icon" className="pr-10 show-for-small-only" width="45" />
              <span className="font-poppins font-size-18l-16m font-weight-500 txt-ddd">Facebook</span>
            </span>
          </div>
          <div className="large-4 medium-6 small-6 cell ptb-10">
            <span className="hover-opacity-50" onClick={(e) => shareOnWhatsapp(e, track)}>
              <img src={whats_app_icon} alt="Copy Link Icon" className="pr-10 hide-for-small-only" width="55" />
              <img src={whats_app_icon} alt="Copy Link Icon" className="pr-10 show-for-small-only" width="45" />
              <span className="font-poppins font-size-18l-16m font-weight-500 txt-ddd">WhatsApp</span>
            </span>
          </div>
          <div className="large-4 medium-6 small-6 cell ptb-10">
            <span className="hover-opacity-50" onClick={(e) => shareOnInstagram(e, track)}>
              <img src={instagram_icon} alt="Copy Link Icon" className="pr-10 hide-for-small-only" width="55" />
              <img src={instagram_icon} alt="Copy Link Icon" className="pr-10 show-for-small-only" width="45" />
              <span className="font-poppins font-size-18l-16m font-weight-500 txt-ddd">Instagram</span>
            </span>
          </div>
          <div className="large-4 medium-6 small-6 cell ptb-10">
            <span className="hover-opacity-50" onClick={(e) => shareOnTikTok(e, track)}>
              <img src={tik_tok_icon} alt="Copy Link Icon" className="pr-10 hide-for-small-only" width="55" />
              <img src={tik_tok_icon} alt="Copy Link Icon" className="pr-10 show-for-small-only" width="45" />
              <span className="font-poppins font-size-18l-16m font-weight-500 txt-ddd">Tik ok</span>
            </span>
          </div>
        </div>

        <div className="horizontal-container justify-right bt1-555 ptb-10 pr-10">
          <Link className="font-poppins font-size-18l-16m font-weight-500" onClick={onClose}>Close</Link>
        </div>
      </div >
    </div >
  );
};

export default SharePanel;
